import ApplicationController from './application';

export default class extends ApplicationController {
  static targets = [
    'modal',
    'backdrop',
    'searchInput',
    'results',
    'selectedUser',
    'selectedName',
    'selectedEmail',
    'uidSection',
    'uidInput',
    'form',
    'userIdField',
    'uidField',
    'submitButton'
  ];

  static values = {
    searchUrl: String
  };

  connect() {
    this.selectedUserId = null;
    this.searchTimeout = null;
  }

  open() {
    this.modalTarget.classList.remove('hidden');
    this.backdropTarget.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
    this.searchInputTarget.focus();
  }

  close() {
    this.modalTarget.classList.add('hidden');
    this.backdropTarget.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
    this.resetForm();
  }

  resetForm() {
    this.searchInputTarget.value = '';
    this.resultsTarget.innerHTML = '';
    this.selectedUserTarget.classList.add('hidden');
    this.uidSectionTarget.classList.add('hidden');
    this.uidInputTarget.value = '';
    this.selectedUserId = null;
    this.userIdFieldTarget.value = '';
    this.uidFieldTarget.value = '';
    this.submitButtonTarget.disabled = true;
  }

  search() {
    // Debounce the search
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(() => {
      this.performSearch();
    }, 300);
  }

  async performSearch() {
    const query = this.searchInputTarget.value.trim();

    if (query.length < 2) {
      this.resultsTarget.innerHTML = '';
      return;
    }

    try {
      const response = await fetch(`${this.searchUrlValue}?query=${encodeURIComponent(query)}`, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });

      if (response.ok) {
        const html = await response.text();
        // Turbo will handle the stream update
        Turbo.renderStreamMessage(html);
      }
    } catch (error) {
      console.error('Search failed:', error);
    }
  }

  selectUser(event) {
    const target = event.currentTarget;
    this.selectedUserId = target.dataset.userId;
    const userName = target.dataset.userName;
    const userEmail = target.dataset.userEmail;

    // Update display
    this.selectedNameTarget.textContent = userName;
    this.selectedEmailTarget.textContent = userEmail;
    this.selectedUserTarget.classList.remove('hidden');
    this.uidSectionTarget.classList.remove('hidden');

    // Clear search
    this.searchInputTarget.value = '';
    this.resultsTarget.innerHTML = '';

    // Update hidden field
    this.userIdFieldTarget.value = this.selectedUserId;

    // Focus UID input
    this.uidInputTarget.focus();

    this.updateSubmitButton();
  }

  clearSelection() {
    this.selectedUserId = null;
    this.selectedUserTarget.classList.add('hidden');
    this.uidSectionTarget.classList.add('hidden');
    this.uidInputTarget.value = '';
    this.userIdFieldTarget.value = '';
    this.uidFieldTarget.value = '';
    this.submitButtonTarget.disabled = true;
    this.searchInputTarget.focus();
  }

  updateSubmitButton() {
    const hasUser = this.selectedUserId !== null;
    const hasUid = this.uidInputTarget.value.trim().length > 0;
    this.submitButtonTarget.disabled = !(hasUser && hasUid);
  }

  submit(event) {
    // Update the hidden UID field before submission
    this.uidFieldTarget.value = this.uidInputTarget.value.trim();

    if (!this.selectedUserId || !this.uidFieldTarget.value) {
      event.preventDefault();
      return;
    }

    // Let the form submit normally
  }
}
